import Button from 'atoms/Button/button';
import { Typography } from 'foundations/typography';
import React from 'react';
import styled, { createGlobalStyle } from 'styled-components';
import { flexbox, space } from 'styled-system';
const btnStyle = {
    borderRadius: '8px',
    marginTop: '30px',
};
function Errors({
    errorIcon,
    header,
    subText,
    buttonText,
    iconAltText,
    handleClick,
}) {
    return (
        <>
            <PageContainerOverride />
            <Container justifyContent='center'>
                <Box
                    p={2}
                    flexDirection='column'
                    justifyContent='center'
                    alignItems='center'
                >
                    <SVGWrapper>
                        <img src={errorIcon} alt={iconAltText} />
                    </SVGWrapper>
                    <Typography variant='h5' color='ambience.2' mt={4}>
                        {header}
                    </Typography>
                    <Typography variant='subtext1' color='ambience.13' mt={1}>
                        {subText}
                    </Typography>
                    <BtnContainer>
                        <Button
                            variant='primary'
                            style={btnStyle}
                            onClick={handleClick}
                        >
                            <Typography variant='span' color='ambience.0'>
                                {buttonText}
                            </Typography>
                        </Button>
                    </BtnContainer>
                </Box>
            </Container>
        </>
    );
}
export default Errors;
const Container = styled.div`
    display: flex;
    ${flexbox}
    min-height: calc(100vh - 210px);
    @media (max-width: 768px) and (orientation: portrait) {
        min-height: calc(100vh - 350px);
    }
`;
const Box = styled.div`
    ${space}
    ${flexbox}
    display: flex;
    max-width: 600px;
    width: 100%;
    text-align: center;
    @media (max-width: 768px) {
        h5 {
            margin-top: 8px;
            font-size: 24px;
            line-height: 30px;
        }
    }
`;
const BtnContainer = styled.div`
    width: 200px;
`;
const SVGWrapper = styled.div`
    img {
        max-width: 100%;
        width: 30vw;
        @media (max-width: 768px) {
            max-width: 80%;
            width: 50vw;
        }
    }
`;
const PageContainerOverride = createGlobalStyle`
    .page-container {
        max-width: 100% !important;
    }
    .page--fill{
        min-height: 0;
    }
`;
